import debounce from 'debounce';
// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import * as Styles from './BackgroundImage.scss';
export default function BackgroundImage(props) {
    const { src, isNowPlaying = false } = props;
    useStyles(Styles);
    const [overlayGradientTop, setOverlayGradientTop] = useState(0);
    const [lockableGradientTop, setLockableGradientTop] = useState(window.innerHeight);
    const debouncedHandleViewportChange = debounce(handleViewportChange, 10);
    useEffect(() => {
        if (!isNowPlaying) {
            window.addEventListener('scroll', debouncedHandleViewportChange);
            window.addEventListener('resize', debouncedHandleViewportChange);
        }
        return () => {
            window.removeEventListener('scroll', debouncedHandleViewportChange);
            window.removeEventListener('resize', debouncedHandleViewportChange);
        };
    }, []);
    return src ? (React.createElement("div", null,
        React.createElement("div", { className: isNowPlaying ? Styles.container2 : Styles.container, style: {
                backgroundImage: `url(${src.replace(/_QL\d+_/, '_QL50_')})`,
            } }),
        !isNowPlaying ? (React.createElement("div", null,
            React.createElement("div", { className: [Styles.overlayGradient, Styles.gradient].join(' '), style: {
                    top: overlayGradientTop,
                } }),
            React.createElement("div", { className: [Styles.lockableGradient, Styles.gradient].join(' '), style: {
                    top: lockableGradientTop,
                } }))) : null)) : null;
    function handleViewportChange() {
        const { innerHeight, scrollY } = window;
        const scrollOffset = innerHeight - scrollY;
        setOverlayGradientTop(scrollY * -1);
        setLockableGradientTop(Math.max(0, scrollOffset));
    }
}
